/**
 * THE GLOBAL SEARCH HOTKEY — owner, 2026-09-29: 加入一個 Global hot key `shift + ctrl + F`
 * 讓 webapp, mac app 可以直接開啟 Global search.
 *
 * Ctrl+Shift+F, and Cmd+Shift+F on a Mac — every other shortcut in this app takes Cmd or
 * Ctrl (Cmd/Ctrl+F, +J, +Shift+G), and this one keeps that. SHIFT is what tells it apart
 * from Cmd/Ctrl+F, which stays the search inside the open conversation; Alt is left out so
 * a layout that types characters with it keeps them.
 *
 * `code`, not `key`: with Shift held `key` is 'F', and on some layouts the letter under
 * that finger is not an F at all. The shortcut means the physical key (Cmd+Shift+G's
 * reasoning, App.tsx).
 */
export function isGlobalSearchKey(e: {
  ctrlKey: boolean
  metaKey: boolean
  shiftKey: boolean
  altKey: boolean
  code: string
}): boolean {
  return (e.ctrlKey || e.metaKey) && e.shiftKey && !e.altKey && e.code === 'KeyF'
}
